export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_PRODUCTION = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';
export const IS_STAGE_ACTIVATED = !!process.env.IS_STAGE;
export const IS_BROWSER = typeof window !== 'undefined';
export const APOSTRO_API_URL = process.env.APOSTRO_API_URL || 'https://prod.apostro.io';
export const DEBUG_FETCHES = false;
